import { REPORT_FETCHED, LOG_OUT } from "../types";

const INITIAL_STATE = [];

export default function report(state = INITIAL_STATE, action = {}) {
  switch (action.type) {
    case REPORT_FETCHED:
      return action.data;
    case LOG_OUT:
      return INITIAL_STATE;
    default:
      return state;
  }
}
